import { routes } from "src/shared/routes";
import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  PassGroupCard,
  TERMS_AND_CONDITION,
} from "./helper";
import desktopBannerImage from "public/images/nyyankees_pass/yankees_banner_lg.jpg";
import mobileBannerImage from "public/images/nyyankees_pass/yankees_banner_sm.jpg";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const nyyankees_pass: TTeamConfig = {
  TEAM_SCHEMA: "nyyankees_pass",
  TEAM_FULL_NAME: "New York Yankees",
  BROWSER_TITLE: "Yankees Ballpark Pass",
  CLIENT_ID: "f6bde69252f3.seasonshare.nyyreg-nyyankees.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#003087",
    COLORS_SECONDARY: "#0C2340",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_PASS_GROUP_ENABLED: true,
    PASS_GROUP_CARDS: [PassGroupCard],
    DISABLE_SIT_WITH_FRIENDS: true,
    IS_CROWD_HANDLER_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    FOOTER: {
      LINKS: FooterLinks,
      COPYRIGHT_TEXT: <>{new Date().getFullYear()} &copy;</>,
    },
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      PHONE_INPUT_DESCRIPTION:
        "Please enter your phone number to verify your account — we won’t send any texts or share your number with anyone.",
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/NYY-3.png",
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB-3/Yankees-Assets/NYY_25_BallparkPass_SiteHeader_1920x450.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB-3/Yankees-Assets/NYY_25_BallparkPass_SiteHeader_375x550.jpg",
    GROUP_INVITE_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB-3/Yankees-Assets/NYY_25_BallparkPass_SiteHeader_1920x450.jpg",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/NY Yankees Ballpark/BallparkPass_BGImage_3_1920x1080.png",
  },

  LANGUAGES: {
    FAQS: FAQS,
    TERMS_AND_CONDITION: TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE: PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
